import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Project from "~/models/project";
import Window from "~/views/identity/window";

interface ProjectCardProps {
  project: Project;
  className?: string;
}

const ProjectCard: React.FC<ProjectCardProps> = ({
  project,
  className = "",
}) => {
  const image = project.imageAsset?.imageFile
    ? getImage(project.imageAsset.imageFile as any)
    : null;

  return (
    <a
      href={project.linkUrl}
      target="_blank"
      rel="noopener"
      className={`flex flex-col gap-4 sm:gap-6 lg:gap-8 w-full p-4 sm:p-6 lg:p-8 hover:bg-neutral-99 transition-colors rounded-[24px] sm:rounded-[32px] lg:rounded-[40px] ${className}`}
    >
      {/* Image Area */}
      <div className="border border-neutral-90 rounded-[24px] sm:rounded-[32px] lg:rounded-[40px] h-[240px] sm:h-[300px] lg:h-[392px] w-full relative overflow-hidden">
        {image ? (
          <GatsbyImage
            image={image}
            alt={project.imageAlt || project.title || "Project image"}
            className="w-full h-full rounded-[24px] sm:rounded-[32px] lg:rounded-[40px]"
            style={{ height: "100%" }}
            imgStyle={{ objectFit: "cover" }}
          />
        ) : (
          <div className="w-full h-full bg-neutral-98 rounded-[24px] sm:rounded-[32px] lg:rounded-[40px]" />
        )}
      </div>

      {/* Content Area */}
      <div className="flex flex-col gap-4 sm:gap-6 lg:gap-8 w-full">
        <div className="flex flex-col gap-2 text-black palt tracking-[0.01em]">
          <h3 className="font-[800] text-[16px] sm:text-[18px] lg:text-[22px] leading-[24px] sm:leading-[32px] lg:leading-[52px]">
            {project.title}
          </h3>
          <p className="font-[350] text-sm sm:text-base lg:text-base leading-6 sm:leading-7 lg:leading-8">
            {project.shortDescription}
          </p>
        </div>

        {/* Link Button */}
        {/* <a
          href={linkUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2.5 px-5 py-2.5 border border-black rounded-[30px] bg-white hover:bg-neutral-99 transition-colors w-fit"
        >
          <span className="font-medium text-lg text-black font-base">
            {linkText}
          </span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 3H21V9"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10 14L21 3"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a> */}
      </div>
    </a>
  );
};

export default ProjectCard;
